import React from "react";

function BuyNowPage() {
  const [isVehicleModalOpen, setIsVehicleModalOpen] = React.useState(false);
  const [isVehicleDrawerVisible, setIsVehicleDrawerVisible] = React.useState(false);
  const [vehicleNumber, setVehicleNumber] = React.useState("");
  const { buyNowHighlights, insuranceCatalog } = window.AppData.buyNowContent;
  const featuredInsurance = insuranceCatalog.find((item) => item.type === "car");
  const sideCards = insuranceCatalog.filter(
    (item) => item.type === "bike" || item.type === "commercial"
  );
  const bottomCards = insuranceCatalog.filter(
    (item) => item.type === "life" || item.type === "health" || item.type === "term"
  );
  const insuranceImages = {
    car: "https://images.pexels.com/photos/9211377/pexels-photo-9211377.jpeg?auto=compress&cs=tinysrgb&w=1200",
    bike: "https://images.pexels.com/photos/27853252/pexels-photo-27853252.jpeg?auto=compress&cs=tinysrgb&w=1200",
    commercial:
      "https://images.unsplash.com/photo-1768697581060-52e2edbee7fa?auto=format&fit=crop&w=1200&q=80",
    health:
      "https://images.unsplash.com/photo-1666886573419-aaaca27447de?auto=format&fit=crop&w=1200&q=80",
    life: "https://images.unsplash.com/photo-1763631019224-07719a29f76e?auto=format&fit=crop&w=1200&q=80",
    term: "https://images.pexels.com/photos/8210429/pexels-photo-8210429.jpeg?auto=compress&cs=tinysrgb&w=1200",
  };

  React.useEffect(() => {
    if (isVehicleModalOpen) {
      const frame = window.requestAnimationFrame(() => {
        setIsVehicleDrawerVisible(true);
      });

      return () => window.cancelAnimationFrame(frame);
    }

    setIsVehicleDrawerVisible(false);
    return undefined;
  }, [isVehicleModalOpen]);

  const openVehicleDrawer = () => {
    setIsVehicleModalOpen(true);
  };

  const closeVehicleDrawer = () => {
    setIsVehicleDrawerVisible(false);
    window.setTimeout(() => {
      setIsVehicleModalOpen(false);
    }, 280);
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-[radial-gradient(circle_at_top_left,rgba(255,123,84,0.18),transparent_24%),radial-gradient(circle_at_85%_18%,rgba(240,178,71,0.16),transparent_18%),radial-gradient(circle_at_bottom_left,rgba(99,199,171,0.18),transparent_24%),linear-gradient(180deg,#fff8f0_0%,#f6fbff_52%,#eefaf7_100%)] text-ink">
      <div className="pointer-events-none absolute inset-0 opacity-70">
        <div className="absolute -left-16 top-28 h-64 w-64 rounded-full bg-peach/20 blur-3xl"></div>
        <div className="absolute right-8 top-24 h-48 w-48 rounded-full bg-amber/30 blur-3xl"></div>
        <div className="absolute bottom-10 left-1/3 h-56 w-56 rounded-full bg-mint/20 blur-3xl"></div>
      </div>

      <header className="relative border-b border-sky-300/60 bg-white/78 px-4 py-3 backdrop-blur-sm md:px-8">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <a href="/" className="flex items-center gap-3">
            <div className="grid h-12 w-12 place-items-center rounded-full bg-gradient-to-br from-peach to-coral text-sm font-extrabold text-white shadow-[0_12px_30px_rgba(225,95,56,0.24)]">
              CG
            </div>
            <div>
              <p className="m-0 font-display text-lg font-bold text-ink">CoverGrid</p>
              <p className="m-0 text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">
                Insurance Hub
              </p>
            </div>
          </a>

          <div className="flex flex-wrap items-center gap-3 text-sm font-semibold text-slate-500">
            <a
              href="/agent-dashboard"
              className="inline-flex items-center gap-2 rounded-full border border-white/90 bg-white/92 px-4 py-2 text-ink shadow-[0_8px_22px_rgba(53,85,130,0.08)] transition hover:-translate-y-0.5 hover:text-coral"
            >
              Dashboard
            </a>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/90 bg-white/92 px-4 py-2 shadow-[0_8px_22px_rgba(53,85,130,0.08)]">
              Need Help
            </span>
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/90 bg-white/92 text-slate-400 shadow-[0_8px_22px_rgba(53,85,130,0.08)]">
              ?
            </span>
            <div className="flex items-center gap-3 rounded-full border border-white/90 bg-white/92 px-3 py-2 shadow-[0_8px_22px_rgba(53,85,130,0.08)]">
              <div className="grid h-9 w-9 place-items-center rounded-full bg-gradient-to-br from-peach to-coral text-sm font-bold text-white shadow-[0_10px_20px_rgba(225,95,56,0.18)]">
                SP
              </div>
              <div className="leading-tight">
                <p className="m-0 text-sm font-bold text-ink">Shyam Panda</p>
                <p className="m-0 text-xs text-slate-400">VR000007</p>
              </div>
            </div>
          </div>
        </div>
      </header>

      <main className="relative px-4 py-8 md:px-8 lg:px-10">
        <section className="grid gap-10 lg:grid-cols-[1.08fr_0.92fr] lg:items-start">
          <div className="relative pt-5">
            <div className="absolute -left-2 top-3 h-28 w-28 rounded-full bg-peach/15 blur-2xl"></div>
            <div className="relative">
              <h1 className="font-display text-4xl font-bold tracking-[-0.06em] text-ink md:text-[3.45rem]">
                CoverGrid Insurance
              </h1>
              <p className="mt-5 max-w-2xl text-2xl font-medium leading-9 text-slate-600">
                We offer a wide range of insurance and financial protection
                services, including:
              </p>

              <ul className="mt-6 grid gap-4 pl-3 text-xl leading-8 text-slate-700">
                {buyNowHighlights.map((item) => (
                  <li
                  key={item}
                  className="flex gap-4 rounded-2xl border border-white/70 bg-white/55 px-4 py-3 shadow-[0_14px_30px_rgba(55,92,143,0.07)] backdrop-blur-sm"
                >
                    <span className="mt-2.5 h-2.5 w-2.5 rounded-full bg-gradient-to-br from-peach to-coral"></span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 flex flex-wrap gap-3">
                <span className="inline-flex rounded-full bg-gradient-to-br from-peach to-coral px-5 py-3 font-semibold text-white shadow-[0_16px_30px_rgba(225,95,56,0.24)]">
                  Instant buying support
                </span>
                <span className="inline-flex rounded-full border border-white/80 bg-white/78 px-5 py-3 font-semibold text-slate-600 shadow-[0_14px_28px_rgba(56,88,136,0.08)]">
                  48+ insurer partners
                </span>
              </div>

              <p className="mt-8 max-w-2xl text-2xl leading-9 text-slate-600">
                At CoverGrid Insurance, we do not just insure lives. We secure
                futures.
              </p>
            </div>
          </div>

          <div className="grid gap-3 lg:grid-cols-[1.65fr_0.75fr]">
            <article className="relative overflow-hidden rounded-[28px] border border-peach/40 bg-[linear-gradient(180deg,rgba(255,255,255,0.96)_0%,rgba(255,248,240,0.96)_100%)] p-5 shadow-[0_28px_60px_rgba(225,95,56,0.12)]">
              <div className="absolute -right-14 -top-12 h-36 w-36 rounded-full bg-sky/20 blur-2xl"></div>
              <div className="absolute bottom-6 left-6 h-24 w-24 rounded-full bg-peach/10 blur-2xl"></div>
              <div className="flex items-start justify-between gap-4">
                <div>
                  <button
                    type="button"
                    onClick={openVehicleDrawer}
                    className="relative z-10 rounded-full bg-gradient-to-r from-peach to-coral px-4 py-2 text-xs font-extrabold uppercase tracking-[0.14em] text-white shadow-[0_14px_26px_rgba(225,95,56,0.28)]"
                  >
                    Explore Plans
                  </button>
                </div>
                <div className="rounded-full border border-peach/20 bg-white/80 px-3 py-1 text-xs font-bold uppercase tracking-[0.14em] text-coral">
                  Featured
                </div>
              </div>

              <div className="relative mt-8 flex flex-col items-center justify-center gap-4 text-center">
                <h2 className="font-display text-[2rem] font-bold tracking-[-0.04em] text-ink">
                  {featuredInsurance.title}
                </h2>
                <div className="relative h-56 w-full overflow-hidden rounded-[28px] shadow-[inset_0_1px_0_rgba(255,255,255,0.35)]">
                  <img
                    src={insuranceImages[featuredInsurance.type]}
                    alt={featuredInsurance.title}
                    className="h-full w-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-ink/10 to-transparent"></div>
                  <div className="absolute left-5 top-5 rounded-full bg-white/88 px-3 py-1 text-xs font-bold uppercase tracking-[0.14em] text-coral">
                    Best seller
                  </div>
                </div>
                <div className="grid w-full gap-3 sm:grid-cols-3">
                  <div className="rounded-2xl border border-peach/15 bg-white/75 px-4 py-3 text-left shadow-[0_10px_22px_rgba(225,95,56,0.08)]">
                    <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Claim support</p>
                    <p className="mt-1 text-lg font-bold text-coral">24x7</p>
                  </div>
                  <div className="rounded-2xl border border-mint/20 bg-white/75 px-4 py-3 text-left shadow-[0_10px_22px_rgba(99,199,171,0.10)]">
                    <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Garages</p>
                    <p className="mt-1 text-lg font-bold text-mint">650+</p>
                  </div>
                  <div className="rounded-2xl border border-amber/20 bg-white/75 px-4 py-3 text-left shadow-[0_10px_22px_rgba(240,178,71,0.10)]">
                    <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Add-ons</p>
                    <p className="mt-1 text-lg font-bold text-amber">Smart</p>
                  </div>
                </div>
                <p className="max-w-xl text-base leading-7 text-slate-600">
                  {featuredInsurance.description}
                </p>
              </div>
            </article>

            <div className="grid gap-3">
              {sideCards.map((insurance) => (
                <article
                  key={insurance.title}
                  className="group grid min-h-[162px] rounded-[24px] border border-white/80 bg-[linear-gradient(180deg,rgba(255,255,255,0.95)_0%,rgba(246,250,255,0.98)_100%)] p-4 shadow-[0_18px_38px_rgba(43,74,107,0.08)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_24px_44px_rgba(43,74,107,0.14)]"
                >
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <h3 className="font-display text-2xl font-bold tracking-[-0.03em] text-slate-700">
                        {insurance.shortLabel}
                      </h3>
                      <p className="text-sm font-medium text-slate-400">Insurance</p>
                    </div>
                    <div className="h-16 w-16 overflow-hidden rounded-2xl shadow-[0_16px_24px_rgba(58,93,151,0.14)] transition duration-300 group-hover:scale-105">
                      <img
                        src={insuranceImages[insurance.type]}
                        alt={insurance.title}
                        className="h-full w-full object-cover"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <p className="mt-4 text-sm leading-6 text-slate-600">
                    {insurance.description}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="mt-4 grid gap-3 md:grid-cols-2 xl:grid-cols-4">
          {bottomCards.map((insurance) => (
            <article
              key={insurance.title}
              className="group grid min-h-[178px] rounded-[24px] border border-white/80 bg-[linear-gradient(180deg,rgba(255,255,255,0.95)_0%,rgba(246,250,255,0.98)_100%)] p-4 shadow-[0_18px_38px_rgba(43,74,107,0.08)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_24px_44px_rgba(43,74,107,0.14)]"
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <h3 className="font-display text-2xl font-bold tracking-[-0.03em] text-slate-700">
                    {insurance.shortLabel}
                  </h3>
                  <p className="text-sm font-medium text-slate-400">Insurance</p>
                </div>
                <div className="h-16 w-16 overflow-hidden rounded-2xl shadow-[0_16px_24px_rgba(58,93,151,0.14)] transition duration-300 group-hover:scale-105">
                  <img
                    src={insuranceImages[insurance.type]}
                    alt={insurance.title}
                    className="h-full w-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>

              <p className="mt-4 text-sm leading-6 text-slate-600">
                {insurance.description}
              </p>
            </article>
          ))}

          <article className="grid min-h-[178px] place-items-center rounded-[24px] border border-white/80 bg-[linear-gradient(180deg,rgba(255,255,255,0.92)_0%,rgba(238,247,255,0.98)_100%)] p-4 shadow-[0_18px_38px_rgba(43,74,107,0.08)]">
            <div className="text-center">
              <p className="text-lg font-semibold text-slate-400">See all</p>
              <div className="mx-auto mt-3 text-sm font-medium text-slate-500">
                Explore more protection types
              </div>
              <div className="mx-auto mt-6 grid h-16 w-16 place-items-center rounded-full bg-gradient-to-br from-blue-500 to-sky text-4xl font-light text-white shadow-[0_16px_30px_rgba(59,115,221,0.28)]">
                +
              </div>
            </div>
          </article>
        </section>

        <footer className="mt-8 border-t border-sky-300/40 px-1 pt-4 text-sm leading-7 text-slate-600">
          <p className="max-w-6xl">
            CoverGrid brings personal, vehicle, health, business, and long-term
            protection solutions into one guided experience so customers can
            compare categories faster and move ahead with confidence.
          </p>
        </footer>
      </main>

      {isVehicleModalOpen ? (
        <div
          className={`fixed inset-0 z-50 backdrop-blur-sm transition duration-300 ${
            isVehicleDrawerVisible ? "bg-ink/45 opacity-100" : "bg-ink/0 opacity-0"
          }`}
        >
          <button
            type="button"
            aria-label="Close vehicle details panel"
            onClick={closeVehicleDrawer}
            className="absolute inset-0 h-full w-full cursor-default"
          />

          <div
            className={`absolute right-0 top-0 h-full w-full max-w-[560px] overflow-y-auto border-l border-white/80 bg-[radial-gradient(circle_at_top_right,rgba(255,123,84,0.14),transparent_22%),linear-gradient(180deg,rgba(255,255,255,0.99)_0%,rgba(255,248,240,0.99)_100%)] shadow-[-24px_0_60px_rgba(20,48,74,0.20)] transition duration-300 ease-out ${
              isVehicleDrawerVisible ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"
            }`}
          >
            <div className="p-6">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div className="inline-flex rounded-full border border-peach/15 bg-peach/12 px-3 py-2 text-xs font-bold uppercase tracking-[0.18em] text-coral shadow-[0_10px_20px_rgba(225,95,56,0.08)]">
                    Instant Vehicle Lookup
                  </div>
                  <h2 className="mt-4 font-display text-[2.15rem] font-bold tracking-[-0.05em] text-ink">
                    Enter your vehicle number
                  </h2>
                  <p className="mt-3 max-w-md text-sm leading-6 text-slate-500">
                    One quick step to pull smarter plan options for your vehicle.
                  </p>
              </div>

              <button
                type="button"
                onClick={closeVehicleDrawer}
                    className="grid h-10 w-10 place-items-center rounded-full border border-white/90 bg-white text-xl text-slate-400 shadow-[0_10px_22px_rgba(53,85,130,0.08)] transition hover:-translate-y-0.5 hover:text-ink"
              >
                x
              </button>
              </div>

              <div className="relative mt-8 overflow-hidden rounded-[32px] border border-peach/20 bg-[linear-gradient(180deg,rgba(255,255,255,0.98)_0%,rgba(255,250,246,0.98)_100%)] p-6 shadow-[0_22px_46px_rgba(43,74,107,0.10)]">
                <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-peach/10 blur-2xl"></div>
                <div className="absolute left-6 top-24 h-16 w-16 rounded-full bg-mint/10 blur-2xl"></div>
                <label className="block text-sm font-bold uppercase tracking-[0.16em] text-coral">
                  Vehicle Number
                </label>
                <p className="mt-2 text-sm text-slate-500">
                  Example: `MH12AB1234`
                </p>
                <div className="mt-5 rounded-[28px] border-2 border-peach/18 bg-[linear-gradient(180deg,rgba(255,123,84,0.05)_0%,rgba(255,255,255,0.96)_100%)] p-3 shadow-[inset_0_1px_0_rgba(255,255,255,0.65),0_12px_26px_rgba(43,74,107,0.05)]">
                  <input
                    type="text"
                    value={vehicleNumber}
                    onChange={(event) => setVehicleNumber(event.target.value.toUpperCase())}
                    placeholder="Enter vehicle number"
                    className="w-full rounded-[22px] border border-transparent bg-white px-4 py-4 text-lg font-bold uppercase tracking-[0.08em] text-ink shadow-[0_12px_24px_rgba(43,74,107,0.06)] outline-none transition placeholder:normal-case placeholder:tracking-normal placeholder:text-slate-400 focus:border-coral focus:ring-4 focus:ring-peach/15"
                  />
                </div>

                <div className="mt-6 grid gap-3">
                  <button
                    type="button"
                    onClick={() => {
                      const queryVehicleNumber = vehicleNumber.trim() || "MH12AB1234";
                      const basePath = `${window.location.origin}${process.env.PUBLIC_URL || ""}`;
                      window.open(
                        `${basePath}/vehicle-details?vehicle=${encodeURIComponent(queryVehicleNumber)}`,
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }}
                    className="flex items-center justify-between rounded-[24px] bg-gradient-to-r from-peach to-coral px-5 py-4 text-left text-white shadow-[0_18px_32px_rgba(225,95,56,0.28)] transition hover:-translate-y-0.5"
                  >
                    <span>
                      <span className="block text-base font-bold">Continue</span>
                      <span className="mt-1 block text-sm text-white/85">
                        Fetch your vehicle details
                      </span>
                    </span>
                    <span className="rounded-full border border-white/20 bg-white/18 px-3 py-1 text-base font-medium shadow-[inset_0_1px_0_rgba(255,255,255,0.12)]">-&gt;</span>
                  </button>
                </div>
              </div>

            <div className="mt-5 rounded-[24px] border border-white/80 bg-[linear-gradient(180deg,rgba(255,255,255,0.88)_0%,rgba(249,251,255,0.92)_100%)] p-4 shadow-[0_14px_28px_rgba(43,74,107,0.06)]">
              <p className="text-xs font-bold uppercase tracking-[0.16em] text-slate-400">
                More ways to continue
              </p>
              <div className="mt-3 flex flex-col gap-3 text-sm">
              <button
                type="button"
                className="flex items-center justify-between rounded-[20px] border border-transparent bg-white/78 px-4 py-3 text-left font-semibold text-slate-600 shadow-[0_8px_18px_rgba(43,74,107,0.04)] transition hover:border-peach/20 hover:text-coral"
              >
                <span>Proceed without car number</span>
                <span className="text-base text-slate-300">-&gt;</span>
              </button>
              <button
                type="button"
                className="flex items-center justify-between rounded-[20px] border border-transparent bg-white/78 px-4 py-3 text-left font-semibold text-slate-600 shadow-[0_8px_18px_rgba(43,74,107,0.04)] transition hover:border-peach/20 hover:text-coral"
              >
                <span>Brand new car? Click here</span>
                <span className="text-base text-slate-300">-&gt;</span>
              </button>
            </div>
            </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

window.AppPages = window.AppPages || {};
window.AppPages.BuyNowPage = BuyNowPage;
